const collaborationSeparator = /\s*\/\s*|\s+(?:feat\.?|ft\.?|featuring|x|vs\.?)\s+/i;

export function splitArtists(value: string) {
  const trimmed = value.trim();
  if (!trimmed) return [];
  if (trimmed.toLocaleUpperCase() === "AC/DC") return [trimmed];
  return [...new Set(trimmed.split(collaborationSeparator).map((artist) => artist.trim()).filter(Boolean))];
}
